import React from 'react';
import { Spin } from 'antd';

import BookCard from '../../../components/shared/BookCard';
import SectionTitle from '../../../components/shared/SectionTitle';
import { useApi } from '../../../hooks/useApi';

import { Section, FeaturedRow } from '../styles';

export default function FeaturedItems({ featuredBookIds, sellerId }) {
  const { data: allBooks, loading } = useApi(`/sellers/${sellerId}/books`);

  if (loading) {
    return (
      <Section>
        <SectionTitle title="Destacados" />
        <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />
      </Section>
    );
  }

  const featuredIds = featuredBookIds || [];
  const featuredBooks = (allBooks || []).filter((b) => featuredIds.includes(b.id));

  if (featuredBooks.length === 0) {
    return null;
  }

  return (
    <Section>
      <SectionTitle title="Destacados" />
      <FeaturedRow>
        {featuredBooks.map((book) => (
          <BookCard
            key={book.id}
            id={book.id}
            title={book.title}
            author={book.authorName}
            price={book.price}
            originalPrice={book.originalPrice}
            condition={book.condition}
            coverImage={book.coverImage}
            showAddToCart
          />
        ))}
      </FeaturedRow>
    </Section>
  );
}
